import React, { useCallback, useEffect, useState } from "react";
import TestimonialCard from "../../Components/TestimonialCard/TestimonialCard";
import { testimonialsData } from "../../Utils/data";

const Testimonials = () => {
  const [testimonialsLength, setTestimonialsLength] = useState(10);
  const [leftIndxes, setLeftIndxes] = useState([]);
  useEffect(() => {
    let left = [];
    for (let i = 0; i < testimonialsLength; i += 4) {
      left = [...left, ...[i, i + 1]];
    }
    setLeftIndxes(left);
  }, [testimonialsLength]);

  const loadMoreTestimonials = useCallback(() => {
    if (testimonialsLength === testimonialsData?.length) return;
    setTestimonialsLength(testimonialsLength + 10);
  }, [testimonialsLength]);

  return (
    <div className="container mx-auto py-20 sm:28 text-center transition-all">
      <p className="font-font-Montserrat font-semibold text-[32px] sm:text-[48px] text-[#141414] uppercase leading-[32px] sm:leading-[62px]">
        Testimonials
      </p>
      <p className="font-font-Titillium font-normal text-[18px] sm:text-[24px] text-[#262626] leading-[21px] sm:leading-[31px]">
        Check out what our are Customers saying
      </p>
      {testimonialsData?.slice(0, testimonialsLength)?.map((item, index) => (
        <TestimonialCard
          testimonial={item}
          index={index}
          key={index}
          leftIndxes={leftIndxes}
        />
      ))}
      {testimonialsLength <= testimonialsData?.length && (
        <div className="flex justify-center items-center py-8 transition-all">
          <button
            className="font-font-Titillium font-bold text-[18px] text-[#FAAD14] leading-[27px] underline uppercase tracking-[0.078em]"
            onClick={loadMoreTestimonials}
          >
            View more testimonials
          </button>
        </div>
      )}
    </div>
  );
};

export default Testimonials;
